import { axios } from '@Root/API'

export const get = (id, page) => {
  return axios.get(`attachment/${id}/history`, {
    params: {
      page,
    },
  })
}
